import React, { useEffect, useState } from 'react';
import UpcomingGames from '@/pages/intelligence/pages/Potential/UpcomingGames/components/UpcomingGames';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';
import type { TopchartFilterCfgType } from '@intelligence/types/topchart';
import {
  commonMobileDefaultFilterValue,
  handlePotentialUpcomingFilterParamsToApi,
} from '@/pages/intelligence/pages/TopCharts/_config/topchartFilterCfg';
import { FilterTimeType } from '@intelligence/utils/filterUtils';
import useEarliesTimeHasData from '@/pages/intelligence/hooks/useEarliesTimeHasData';
import { hasDataTimerParams } from '@intelligence/utils/timerDefautParams';
import { getUpcomingCompanyList } from '@/pages/intelligence/services/filter';
import moment from 'moment';
import { SENSOR_TOWER_TAG_KEYS } from '@/pages/intelligence/components/Filter/FilterBase/_config';
import useMarketFilterApi, {
  MarketSpecailType,
} from '@/pages/intelligence/hooks/useMarketSelector';
import useSenTowerTag from '@/pages/intelligence/hooks/useSenTowerTag';
import { history, useIntl } from 'umi';
import { getTopUpcomingCustomValidUrlParams, topchartUpcomingMobileValidCfg, hasShortLinkRatio } from '@intelligence/_config/urlPageValidCfg';
import { getOriginalShortLinkFilter, URL_FILTER_KEY, URL_CHART_TYPE } from '@intelligence/utils/urlPathCfg';
import { getMobileTopChartsFilterTips } from '@intelligence/pages/TopCharts/MobileGames/_config/mobileTopChartsFilterTips';

export default function Upcoming(props: any) {
  const { formatMessage } = useIntl();
  const {
    entityType = 'mobile',
    pageLogInfo = dbiPageLogMes.potentialUpcomingGamesMobileGame,
    enableDefaultCheck,
    // 用于 Potential 模块独立页等不需要分组的复用场景；Top Charts Mobile Upcoming 入口不传此 prop，保留分组
    disableFilterGrouping = false,
    // 当为 true 时启用筛选器吸顶；默认 true
    enableStickyFilter = true,
    // Top Charts 手游榜单入口启用筛选器 hover 文案
    enableMobileTopChartsFilterHoverTips = false,
    pageId,
  } = props;

  const hasUrlShortLink = hasShortLinkRatio.topMobileUpcoming;
  const [shortLinkLoading, setShortLinkLoading] = useState(hasUrlShortLink);
  const [urlCustomParams, setUrlCustomParams] = useState({});
  const [shortLinkValidQuery, setShortLinkValidQuery] = useState({
    [URL_CHART_TYPE]: 'bar',
  });
  const [shortLinkFilterValue, setShortLinkFilterValue] = useState(null);

  const { filterLoading, regionOptions } = useMarketFilterApi({
    filterType: MarketSpecailType.mobliePheat,
  });
  const { tagLoading, tagConfig } = useSenTowerTag({});
  const { latestTimeTypeHasData } = useEarliesTimeHasData({
    filterType: hasDataTimerParams?.mobileUpcoming?.type,
  });

  const initPage = async () => {
    setShortLinkLoading(true);
    // 在url上取token，有则请求接口， 判断异常，返回函数值和url上的其他配置参数
    const { [URL_FILTER_KEY]: urlFilter } = await getOriginalShortLinkFilter();
    if (urlFilter) {
      // 有的筛选器的token时才用后面的参数，没有则不用
      const { params, validQuery } = getTopUpcomingCustomValidUrlParams(history, topchartUpcomingMobileValidCfg);
      setUrlCustomParams({ ...params });
      setShortLinkValidQuery({ ...shortLinkValidQuery, ...validQuery });
      setShortLinkFilterValue(urlFilter);
    }
    setShortLinkLoading(false);
  };

  useEffect(() => {
    buriedPointPage(pageLogInfo);
    // 进入页面时判断是否有tokenQuery等，有则进入
    initPage();
  }, []);

  const defaultFilterValue = {
    ...commonMobileDefaultFilterValue,
  };
  // console.log('defaultFilterValuedefaultFilterValue',defaultFilterValue)
  const groupedFilter = filterKeyMap.defineFilterGroups(
    [
      {
        key: 'popular',
        titleKey: 'dbi_filter_group_popular',
        filterKeys: [
          filterKeyMap.ALL_Games,
          filterKeyMap.ALL_COMPANYS,
          filterKeyMap.RELEASE_TIME,
        ],
      },
      {
        key: 'sensor_tower',
        titleKey: 'dbi_filter_group_sensor_tower',
        iconCode: 'sensortower',
        filterKeys: SENSOR_TOWER_TAG_KEYS,
      },
    ],
    { ungroupedKeys: [filterKeyMap.MY_FILTER] },
  );
  const filterCfg: TopchartFilterCfgType = {
    filterKeyList: groupedFilter.filterKeyList,
    filterGroups: disableFilterGrouping ? undefined : groupedFilter.filterGroups,
    companyFilterParams: {
      entity_type: entityType,
      search_name: '',
      page: 1,
      file_page_size: 500,
      start_release_time: moment().add(1, 'days').format('YYYY-MM-DD'),
      end_release_time: moment().add(6, 'M').format('YYYY-MM-DD'),
      source_metric: {},
    },
    getCompaniesFetch: getUpcomingCompanyList,
    defaultValue: defaultFilterValue,
    resetFilterValue: {
      ...defaultFilterValue,
    },
    specialParams: {
      ...(enableMobileTopChartsFilterHoverTips
        ? { filterTips: getMobileTopChartsFilterTips(formatMessage) }
        : {}),
      regionOptions, // 国家筛选器options,
      defalutMarket: [], // 没取到交集用的默认值
      disableNoChina: true,
      rangeTimeType: FilterTimeType.commonRange,
      disableIegg: false,
      disableAnnie: false,
      sensorTowerTagConfig: tagConfig,
      [filterKeyMap.ALL_Games]: {
        params: { entity_type: entityType, game_type: 'upcoming' },
      }
    },
    showConfirmButton: true,
    haveFilterSaveBtn: true,
    handleFilterToApiParams: (params: any) => handlePotentialUpcomingFilterParamsToApi(params, entityType),
    hasUrlShortLink,
    enableSticky: enableStickyFilter,
  };


  return (
    <UpcomingGames
      entityType={entityType}
      downloadFileName={'Potential_Upcoming Games_Mobile Games'}
      pageLogInfo={pageLogInfo}
      filterCfg={filterCfg}
      pageId={pageId}
      stickyHeaderTitle={enableStickyFilter ? formatMessage({ id: 'dbi_mobile_games' }) : undefined}
      filterLoading={filterLoading || tagLoading || shortLinkLoading}
      releaseTimeComponentDefault={latestTimeTypeHasData}
      urlCustomParams={urlCustomParams}
      shortLinkValidQuery={shortLinkValidQuery}
      shortLinkFilterValue={shortLinkFilterValue}
      enableDefaultCheck={enableDefaultCheck}
    />
  );
}
